var $b105ec2f6a7439c6$exports = {};
//joinus hover animation
const $b105ec2f6a7439c6$var$list = document.querySelector(".s-projectsCategories__right__list");
const $b105ec2f6a7439c6$var$liElements = Array.prototype.slice.call($b105ec2f6a7439c6$var$list.children);
$b105ec2f6a7439c6$var$liElements.forEach((el)=>{
    el.addEventListener("mouseover", ()=>{
        el.children[0].children[0].children[0].classList.add("pink");
        el.children[1].classList.add("long--white");
    });
    el.addEventListener("mouseout", ()=>{
        el.children[0].children[0].children[0].classList.remove("pink");
        el.children[1].classList.remove("long--white");
    });
});


//# sourceMappingURL=join-us.f470b04d.js.map
